import html from "nanohtml";
import type { WidgetUIProps } from "../../types.ts";
import { ArticleCardHorizontalV2 } from "../components/articleCardHorizontalV2.ts";

export function CardStackV2(props: WidgetUIProps): HTMLElement {
  const widgetId = `rw-widget-${Date.now()}-${Math.random()
    .toString(36)
    .slice(2, 11)}`;

  return html`
    <div
      class="rw-widget rw-my-4 renderer-${props.siteRenderer}"
      role="region"
      aria-labelledby="${widgetId}-title"
    >
      <div class="rw-mb-3">
        <hr class="v2 rw-mb-4" aria-hidden="true" />
        <h2 id="${widgetId}-title" class="rw-title-font rw-m-0 rw-text-xl rw-text-black">
          ${props.title}
        </h2>
      </div>
      <nav role="navigation" aria-label="Related articles">
        ${props.posts.map((post, index) => {
          return html`<div class="rw-mb-2">
            ${ArticleCardHorizontalV2({
              ...post,
              logger: props.logger,
            })}
          </div>`;
        })}
      </nav>
      <div class="rw-sr-only" aria-live="polite">
        ${props.posts.length} related articles loaded
      </div>
    </div>
  `;
}
